export const DEALER_UID = 'dealerUid';
